export class PaymentIdRequest{
    paymentsId : number;
    constructor( paymentsId : number){
            this.paymentsId = paymentsId
    }
}